import { plainfieldConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PlainfieldPage() {
  return <CityPageTemplate config={plainfieldConfig} />;
}